// Reverse index of /data/rcCodeLookup.js — given a factory code (e.g. "C-0001"),
// returns { field: "lapel_type", value: "Notch" }. Used by the "Apply to POS / Quick Order"
// flow so codes clicked in the RC Code Book auto-populate the matching dropdown.
//
// Built lazily on first call so we don't pay the cost during initial bundle parse.

import { RC_CODE_LOOKUP } from "./rcCodeLookup";

let _index = null;

function buildIndex() {
  const idx = {};
  for (const [field, valueMap] of Object.entries(RC_CODE_LOOKUP || {})) {
    if (!valueMap || typeof valueMap !== "object") continue;
    for (const [value, code] of Object.entries(valueMap)) {
      if (!code) continue;
      // First-write wins. rcCodeLookup contains synonyms ("Notch" + "Notch Lapel" → C-0001);
      // we keep the cleanest first entry so the dropdown gets the canonical label.
      if (!idx[code]) idx[code] = { field, value };
    }
  }
  return idx;
}

export function codeToFieldValue(code) {
  if (!_index) _index = buildIndex();
  if (!code) return null;
  // Accept "C-0001", "C-0001 (Notch Lapel)", "Notch Lapel C-0001" — extract the code token
  const m = String(code).match(/([A-Z]-[A-Z0-9]{3,5})/);
  const key = m ? m[1] : String(code).trim();
  return _index[key] || null;
}

// Categorise a field name into its garment bucket so we know which styling state to mutate.
//   lapel_type → "jacket"  |  pant_back_pocket_style → "pant"  |  vest_lapel → "vest"  | shirt_collar_style → "shirt"
export function fieldGarmentBucket(field) {
  if (!field) return null;
  if (field.startsWith("shirt_")) return "shirt";
  if (field.startsWith("pant_"))  return "pant";
  if (field.startsWith("vest_"))  return "vest";
  return "jacket";
}

// Strip the garment prefix when present so the resulting key matches the state object's keys.
//   pant_back_pocket_style → back_pocket_style
//   shirt_collar_style     → collar_style
//   lapel_type             → lapel_type   (jacket has no prefix)
export function fieldStateKey(field) {
  if (!field) return null;
  if (field.startsWith("shirt_")) return field.slice("shirt_".length);
  if (field.startsWith("pant_"))  return field.slice("pant_".length);
  if (field.startsWith("vest_"))  return field.slice("vest_".length);
  return field;
}
